import { render, staticRenderFns } from "./WidgetCategoryReviewsListMobile.vue?vue&type=template&id=e6c85a54&scoped=true"
import script from "./WidgetCategoryReviewsListMobile.vue?vue&type=script&lang=js"
export * from "./WidgetCategoryReviewsListMobile.vue?vue&type=script&lang=js"
import style0 from "./WidgetCategoryReviewsListMobile.vue?vue&type=style&index=0&id=e6c85a54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c85a54",
  null
  
)

export default component.exports